import { useCommissionStepStore } from "../../stores/commission/commissionStepStore";

const pending = new Map();
let requestChain = Promise.resolve();
const delay = 800;

function flush(code) {
    const batch = pending.get(code);
    if (!batch) return;
    clearTimeout(batch.timer);
    pending.delete(code);
    requestChain = requestChain.then(() => useCommissionStepStore.getState().adjust(code, {
        target: batch.target,
        operation: batch.operation,
        stepCount: batch.stepCount,
    }));
}

export function queueCommissionAdjustment(code, target, operation) {
    const current = pending.get(code);
    if (current && (current.target !== target || current.operation !== operation)) flush(code);

    const batch = pending.get(code) || { target, operation, stepCount: 0 };
    batch.stepCount += 1;
    clearTimeout(batch.timer);
    batch.timer = setTimeout(() => flush(code), delay);
    pending.set(code, batch);
}

export function flushCommissionAdjustments() {
    for (const code of pending.keys()) flush(code);
}
